import { request } from 'utils/request';

import { Tag, TagType } from 'types';

export const getTagsByType = async (tagType: TagType, tagsSelected?: string[]) => {
  const filter = tagsSelected?.length ? { filter: 'tags', tags: tagsSelected.join(',') } : null;

  const { data } = await request.get<Tag[]>(`/api/internal/tags`, {
    params: {
      type: tagType,
      ...filter,
    },
  });

  return data;
};
